$giper_baza_glob_book $mol_book2_catalog
	menu_title \🌐 Global Explorer
	menu_tools /
		<= Home_link $mol_link
			hint \Your Home
			arg * link <= home_link \
			sub /
				<= Home_link_icon $mol_icon_account
	param \link
	Spread* <= Land* $giper_baza_land_page
		land <= land* $giper_baza_land
		pawn <= pawn* $giper_baza_dict
		tools /
			^
			<= Rights_open $mol_link
				arg * side \rights
				sub /
					<= Rights_open_icon $mol_icon_security
			<= Spread_close
	menu_item_content* /$mol_view
		<= Menu_link*
		<= Land_checked* $mol_check_box
			checked? <=> land_checked*? false
	menu_foot /
		<= Wipe_pick $mol_pick
			hint \Wipe database
			clicks? <=> wipe? null
			align_hor \right
			trigger_content /
				<= Wipe_icon $mol_icon_delete_forever
			bubble_content /
				\Double to wipe database
		- <= Seed_make $mol_button_minor
			hint \Make Seed
			click? <=> seed_make? null
			sub / <= Seed_make_icon $mol_icon_sprout_outline
		<= Land_add $giper_baza_land_grab
			hint \Grab new Land
			align_hor \left
			grab? <=> land_add? null $giper_baza_rank_preset
		<= Update $mol_button_open
			hint \Upload dump
			files? <=> update? /
		<= Dump $mol_button_download
			hint \Download selected
			enabled <= dump_enabled false
			blob <= dump $mol_blob
			file_name <= dump_name \AAAAAAAA_AAAAAAAA.baza
	Rights_page $mol_page
		title \Rights
		tools /
			<= Rights_close $mol_link
				arg * side null
				sub /
					<= Rights_close_icon $mol_icon_close
		body /
			<= Rights_form $giper_baza_land_rights
				land <= land_current $giper_baza_land
